import React, {Fragment, useState} from 'react';
import {v4 as uuidv4} from 'uuid';

const Formulario = ({crearCita}) => {

    //Crear State de citas
    const [cita, setCitas] = useState({
        nombre      : '',
        apellido    : '',
        fecha       : '',
        hora        : '',
        sintomas    : ''
    })

    const [error, setError] = useState(false);

    //Funcion que se ejecuta cada vez que el usario escribe en input
    const handleChange = e => {
        setCitas({
            ...cita,
            [e.target.name] : e.target.value
        })
    }

    //Extraer los valores
    const {nombre, apellido, fecha, hora, sintomas } = cita;

    //Enviar formulario
    const submitCita = e => {
        e.preventDefault();
        
        // Validando si los campos estan vacios
        /* trim() es una funcion que elimina los espacio vacios del string seleccionado */
        if(nombre.trim() === "" || apellido.trim() === "" || fecha.trim() === "" || hora.trim() === "" || sintomas.trim() === ""){
            setError(true);
            return;
        }

        // Eliminar mensaje de error
        setError(false);

        // Asignar ID
        cita.id = uuidv4();

        // Crear Cita
        crearCita(cita);

        // Reiniciar form
        setCitas({
            nombre      : '',
            apellido    : '',
            fecha       : '',
            hora        : '',
            sintomas    : ''
        });

    }

    return (
        <Fragment>
            <h2>Crear Cita</h2>

            {error? <p className="alerta-error"> Todos los campos son obligatorios</p>: null}

            <form
            
                onSubmit={submitCita}

            >
                <label>Nombre Paciente</label>
                <input
                    type="text"
                    name="nombre"
                    className="u-full-width"
                    placeholder="Nombre Paciente"
                    onChange={ handleChange }
                    value={nombre}
                />

                <label>Apellido Paciente</label>
                <input
                    type="text"
                    name="apellido"
                    className="u-full-width"
                    placeholder="Apellido Paciente"
                    onChange={ handleChange }
                    value={apellido}
                    
                />

                <label>Fecha de consulta</label>
                <input
                    type="date"
                    name="fecha"
                    className="u-full-width"
                    onChange={ handleChange }
                    value={fecha}
                />

                <label>Hora</label>
                <input
                    type="time"
                    name="hora"
                    className="u-full-width"
                    onChange={ handleChange }
                    value={hora}
                />

                <label>Sitomas</label>
                <textarea
                    name="sintomas"
                    className="u-full-width"
                    onChange={ handleChange }
                    value={sintomas}

                ></textarea>

                <button
                    type="submit"
                    className="u-full-width button-primary"

                >Agregar Cita</button>
            </form>

        </Fragment>
    );
}
 
export default Formulario;